<template>
  <div class="checkboxInput" :class="{ 'checkboxInput--no-label': !label }">
    <input
      type="checkbox"
      ref="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      :indeterminate="indeterminate"
      :id="`chActive${id}`"
    />
    <label
      @click.prevent="handleClick"
      :for="`chActive${id}`"
      class="custom-form__label"
      :class="{ disabled: disabled }"
      >{{ label }}</label
    >
  </div>
</template>

<script>
  export default {
    name: 'CheckboxInput',
    emits: ['update:modelValue'],
    props: {
      id: {
        type: [String, Number],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      indeterminate: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.checkbox.indeterminate = this.indeterminate;
      });
    },
    methods: {
      handleClick() {
        if (this.disabled) return;
        this.$emit('update:modelValue', !this.modelValue);
      },
    },
    watch: {
      indeterminate(newValue) {
        this.$nextTick(() => {
          this.$refs.checkbox.indeterminate = newValue;
        });
      },
    },
  };
</script>

<!-- ? Стили взяты из style.scss. Следует везде использовать этот компонент и удалить стили из глобального файла -->
<style scoped lang="scss">
  .checkboxInput {
    position: relative;

    input,
    label {
      cursor: pointer;
    }

    input {
      &[type='checkbox'] {
        display: block;
        width: 3px;
        height: 3px;
        position: absolute;
        opacity: 0;
        left: 10px;
        top: 10px;
        z-index: 1;
      }
    }

    // Checked
    input[type='checkbox']:checked + label:before {
      background: url(~@/assets/images/svg/checked.svg) 0 0 no-repeat;
    }

    // Indeterminate
    input[type='checkbox']:indeterminate + label:before {
      background: url(~@/assets/images/svg/indeterminate.svg) 0 0 no-repeat;
    }

    /* Disabled */
    input[type='checkbox']:disabled + label:before {
      filter: grayscale(100%);
      cursor: auto;
    }

    label {
      padding-left: 36px;
      font-size: 16px;
      line-height: 160%;
      color: #1b2f31;
      font-weight: 400 !important;

      &:before {
        z-index: 2;
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0px;
        top: 0px;
        background: url(~@/assets/images/svg/checkbox.svg) 0 0 no-repeat;
        cursor: pointer;
      }

      /* Hover */
      &:hover:before {
        filter: brightness(120%);
      }
    }

    &--no-label {
      input {
        &[type='checkbox'] {
          display: block;
          width: 0;
          height: 0;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }

        label {
          position: absolute;
          margin: 0;
        }
      }
    }
  }
  .checkboxInput > input[type='checkbox'] {
    display: none;
  }

  .disabled {
    cursor: default;
  }
</style>
